import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import styles from "./EditGeneralNotifications.module.scss";
import { MODALS_ENUM } from "@constants/Modals";
import { Button, Divider } from "antd";
import { Input } from "@components/global/new/Input/Input";

type EditGeneralNotificationsProps = CommonModalPropsI & {};

function EditGeneralNotifications(props: EditGeneralNotificationsProps) {
  return <div className={styles.wrapper}>
    <h4 className={styles.title}>
      {props.formatMessage({ id: "modal.editGeneralNotifications.title" })}
    </h4>
    <Divider className={styles.divider} />
    <div className={styles.values}>
      <Input
        outlined
        label={<span className={styles.label}>
          {props.formatMessage({ id: "modal.editGeneralNotifications.title.email" })}
        </span>}
      />
      <Input
        outlined
        label={<span className={styles.label}>
          {props.formatMessage({ id: "modal.editGeneralNotifications.title.tg" })}
        </span>}
      />
      <Input
        outlined
        label={<span className={styles.label}>
          {props.formatMessage({ id: "modal.editGeneralNotifications.title.message" })}
        </span>}
      />
    </div>
    <Divider className={styles.divider} />
    <div className={styles.buttons}>
      <Button type="primary" onClick={props.handleClose}>{props.formatMessage({ id: "modal.editGeneralNotifications.buttons.save" })}</Button>
      <Button onClick={props.handleClose}>{props.formatMessage({ id: "modal.editGeneralNotifications.buttons.cancel" })}</Button>
    </div>
  </div>
}

export default WithModal(MODALS_ENUM.EDIT_GENERAL_NOTIFICATIONS, EditGeneralNotifications);
